import {computed, ref, watch} from "vue";
import {router, usePage} from "@inertiajs/vue3";
import {DsRoute, RouteManager} from "~/helper/RouteManager.ts";
import {findLockerByCode} from "~/composable/pages/stock/lockerSelection.js";

export const lockers_list = ref<Array<any>>([]);

export const flat_lockers_list = computed(() => {
    if (!lockers_list.value) {
        return [];
    }
    return lockers_list.value.flat();
});
export const selected_locker = ref(null);

export const locker_change = ref(false);
watch(selected_locker,function (){
    locker_change.value = true;
});

watch(locker_change,function (){
    setTimeout(function(){
        locker_change.value = false;
    },50)
})

export const locker_order_reverse = ref(false);

const page = usePage();

export const locker_code = ref("");

export const highlight_product_in_locker_id = ref(null);

watch(highlight_product_in_locker_id,function (val){
    if(!val) return;
    setTimeout(function () {
       highlight_product_in_locker_id.value = null;
    },2000);
})

watch([locker_code, flat_lockers_list], ([newValue]) => {
    if (!newValue) {
        selected_locker.value = null;
        return;
    }
    if (newValue.match(/[a-z]/i)) {
        console.warn('Invalid locker code : ' + newValue);
        return;
    }

    selected_locker.value = findLockerByCode(flat_lockers_list.value, newValue);
    if (!selected_locker.value) {
        return;
    }
    // @ts-ignore
    if (page.props.locker_code === newValue) {
        return;
    }

    router.replace({
        url: DsRoute(RouteManager.getCurrentRouteName(), {
            building_slug: page.props.building_slug,
            line_location_code: page.props.line_location_code,
            locker_code: newValue
        }),
        preserveState: true,
        preserveScroll: true,
    });
});

// export const lockerCode = computed({
//     get: () => {
//         return locker_params.lockersCode;
//     },
//     set: (value: string|null) => {
//         if(!value){
//             locker_params.lockersCode = null;
//             return;
//         }
//         if (value.match(/[a-z]/i)) {
//             console.warn('Invalid locker code : ' + value);
//             return;
//         }
//         locker_params.lockersCode = value;
//     }
// });
